import { Skeleton } from "skullet/react";

export function ProfileSkeleton() {
    return (
        <Skeleton loading label="Loading provider">
            <div className="mx-auto flex w-full max-w-7xl flex-col px-6 pt-8">
                <div className="flex flex-col items-center gap-3 md:items-start">
                    <div skullet-block="" className="h-5 w-48 rounded-label" />
                    <div skullet-block="" className="h-9 w-72 rounded-label" />
                </div>
                <div className="mt-6 flex gap-3">
                    <div
                        skullet-block=""
                        className="h-10 w-32 rounded-nested"
                    />
                    <div
                        skullet-block=""
                        className="h-10 w-40 rounded-nested"
                    />
                    <div
                        skullet-block=""
                        className="h-10 w-36 rounded-nested"
                    />
                </div>
                <div
                    skullet-block=""
                    className="mt-6 h-64 w-full rounded-card"
                />
                <div className="mt-8 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(0,1fr)_360px] lg:gap-10">
                    <div className="flex flex-col gap-4">
                        <div
                            skullet-block=""
                            className="h-7 w-40 rounded-label"
                        />
                        <div className="grid grid-cols-2 gap-4">
                            <div
                                skullet-block=""
                                className="h-48 rounded-card"
                            />
                            <div
                                skullet-block=""
                                className="h-48 rounded-card"
                            />
                        </div>
                    </div>
                    <div skullet-block="" className="h-72 rounded-card" />
                </div>
            </div>
        </Skeleton>
    );
}
